"use client";
var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });

// src/components/cosmic/background-accents.tsx
import { motion } from "framer-motion";
import { colorMaps } from "./utils/background-colors.js";
import { jsx, jsxs } from "react/jsx-runtime";
function AccentElements({ colorScheme, intensity }) {
  const colorMap = colorMaps[colorScheme];
  return /* @__PURE__ */ jsxs("div", { className: "absolute inset-0 overflow-hid\
den pointer-events-none", children: [
    /* @__PURE__ */ jsx(
      motion.div,
      {
        className: "absolute top-1/4 left-1/4 w-16 h-16 rounded-full bg-purple-4\
/25 dark:bg-purple-12/15 blur-sm",
        animate: {
          scale: [1, 1.2 * intensity, 1],
          opacity: [0.2, 0.4 * intensity, 0.2]
        },
        transition: {
          duration: 8,
          repeat: Number.POSITIVE_INFINITY,
          ease: "easeInOut"
        }
      }
    ),
    /* @__PURE__ */ jsx(
      motion.div,
      {
        className: "absolute top-1/3 right-1/3 w-24 h-24 rounded-full bg-purple-\
5/20 dark:bg-purple-9/12 blur-sm",
        animate: {
          scale: [1, 1.3 * intensity, 1],
          opacity: [0.15, 0.35 * intensity, 0.15]
        },
        transition: {
          duration: 12,
          repeat: Number.POSITIVE_INFINITY,
          ease: "easeInOut"
        }
      }
    ),
    /* @__PURE__ */ jsx(
      motion.div,
      {
        className: "absolute bottom-1/4 right-1/4 w-20 h-20 rounded-full bg-purp\
le-7/25 dark:bg-purple-10/15 blur-sm",
        animate: {
          scale: [1, 1.1 * intensity, 1],
          opacity: [0.18, 0.38 * intensity, 0.18]
        },
        transition: {
          duration: 10,
          repeat: Number.POSITIVE_INFINITY,
          ease: "easeInOut"
        }
      }
    ),
    /* @__PURE__ */ jsx(
      motion.div,
      {
        className: `absolute top-1/3 left-1/6 w-2 h-2 bg-${colorMap.accent1} rou\
nded-full opacity-60`,
        animate: {
          scale: [1, 2 * intensity, 1],
          opacity: [0.4, 0.8 * intensity, 0.4]
        },
        transition: {
          duration: 4,
          repeat: Number.POSITIVE_INFINITY,
          ease: "easeInOut"
        }
      }
    ),
    /* @__PURE__ */ jsx(
      motion.div,
      {
        className: `absolute top-2/3 right-1/6 w-1 h-1 bg-${colorMap.accent2} ro\
unded-full opacity-70`,
        animate: {
          y: [0, -20 * intensity, 0],
          opacity: [0.5, 0.9 * intensity, 0.5]
        },
        transition: {
          duration: 6,
          repeat: Number.POSITIVE_INFINITY,
          ease: "easeInOut"
        }
      }
    )
  ] });
}
__name(AccentElements, "AccentElements");
export {
  AccentElements
};
